import { Bot, Check, Eye, EyeOff, Headphones, MessageCircle, Mic2 } from "lucide-react";
import { useState } from "react";
import { Link, useLocation } from "../lib/router";
import { useAuth } from "../contexts";
import { PWAInstallButton } from "../components/PWAInstallButton";

export default function Login() {
  const { login } = useAuth();
  const [, navigate] = useLocation();
  const [email, setEmail] = useState("admin@linguahome.local");
  const [password, setPassword] = useState("admin123");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (event: React.FormEvent) => {
    event.preventDefault(); setError(""); setLoading(true);
    try { await login(email, password); navigate("/dashboard"); }
    catch (err) { setError(err instanceof Error ? err.message : "Não foi possível entrar."); }
    finally { setLoading(false); }
  };
  return <div className="auth-page">
    <section className="auth-hero">
      <div className="hero-brand"><Bot/> LinguaHome XR</div>
      <div className="hero-content"><span className="eyebrow">CONVERSAÇÃO QUE PARECE REAL</span><h1>Aprenda um idioma vivendo a conversa.</h1><p>Entre em cenários futuristas visíveis e converse por voz com AURA, um tutor robótico animado que adapta ritmo, sotaque, papel e nível.</p>
        <div className="feature-list"><span><Mic2/><b>Conversa por voz</b><small>Fale naturalmente e receba respostas em tempo real.</small></span><span><MessageCircle/><b>Cenários imersivos</b><small>Explore casa, trabalho, viagem, museu e outros ambientes com AURA em movimento.</small></span><span><Headphones/><b>Ritmo sob controle</b><small>De extremamente lento até velocidade nativa.</small></span></div>
      </div>
      <div className="language-orbs"><i>EN</i><i>ES</i><i>FR</i><i>中文</i></div>
    </section>
    <section className="auth-panel"><form className="auth-card" onSubmit={submit}><div className="auth-logo"><Bot/></div><h2>Bem-vindo de volta</h2><p>Entre para continuar sua prática diária.</p>
      {error && <div className="form-error">{error}</div>}
      <label>E-mail<input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></label>
      <label>Senha<div className="password-field"><input type={show ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} required /><button type="button" onClick={() => setShow(!show)}>{show ? <EyeOff/> : <Eye/>}</button></div></label>
      <button className="primary-button full" disabled={loading}>{loading ? "Entrando..." : "Entrar"}</button>
      <div className="demo-box"><Check/><div><b>Acesso demonstrativo</b><span>admin@linguahome.local · admin123</span></div></div><PWAInstallButton />
      <p className="auth-link">Ainda não possui conta? <Link href="/register">Criar conta</Link></p>
    </form></section>
  </div>;
}
